import { hash } from 'rsvp';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import type ActionChangeoverSettingsController from 'uplisting-frontend/pods/action-changeover-settings/controller';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default class ActionChangeoverSettingsRoute extends PermittedRoute {
  @service featureFlags!: Services['feature-flags'];

  @service('repositories/checklist-template')
  checklistTemplateRepository!: Services['repositories/checklist-template'];

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  permission = 'automate.cleaning';

  async beforeModel(transition: Transition): Promise<void> {
    await super.beforeModel(transition);

    if (transition.isAborted) {
      return;
    }

    if (!this.featureFlags.gate.enabled('task_centre')) {
      this.router.replaceWith('action');
    }
  }

  // Every property, not just the ones with a checklist: a property whose
  // checklist has not been written yet still needs a row to start from.
  model() {
    return hash({
      templates: this.checklistTemplateRepository.findAll(),
      properties: this.propertyRepository.findAll(),
      changeoverSettings: this.store.findAll('changeover-setting'),
    });
  }

  setupController(
    controller: ActionChangeoverSettingsController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    const bulkChangeoverSetting = this.store.createRecord(
      'bulk-changeover-setting',
      { changeoverSettings: model.changeoverSettings },
    );

    Object.assign(controller, {
      bulkChangeoverSetting,
      changeoverSettings: model.changeoverSettings,
    });
  }

  resetController(
    controller: ActionChangeoverSettingsController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    // Before unloading: a panel left open would re-render against a destroyed record.
    controller.editingTemplate = null;
    this.checklistTemplateRepository.unloadAll();
    this.store.unloadAll('bulk-changeover-setting');
    this.store.unloadAll('changeover-setting');
  }
}
